/// <amd-module name="Feed-Empty/EmptyViewComponent" />
import * as React from "react";

import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";

class EmptyViewComponent extends VssComponent<IVssComponentProperties, {}> {
    public constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <div className="flex flex-grow flex-center justify-center fontSizeXL">
                Empty view for measuring performance!
            </div>
        );
    }

    public componentDidMount(): void {
        super.componentDidMount();

        const performanceService: IVssPerformanceService = this.context.pageContext.getService<IVssPerformanceService>(
            "IVssPerformanceService"
        );
        performanceService.markTimeToInteractive("feeds", "emptyView");
    }
}

VssComponent.register("emptyView", EmptyViewComponent);
